import Vue from 'vue'
import '@/plugins/keycloak'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store'
import '@/plugins/moment'


Vue.config.productionTip = false

new Vue({
    vuetify,
    store,
    router,
    render: h => h(App)
}).$mount('#app')
